import { watch, type Ref } from "vue";
import { useDocumentVisibility, useEventListener } from "@vueuse/core";

/** How old a background pass may be before the member returning to the tab or reconnecting triggers one now. */
export const ResumeCatchUpAfterMilliseconds = 60_000 as const;

/**
 * Calls `onResume` when the member comes back to the tab (hidden -> visible) or the browser comes back online
 * (data-11, lifecycle-11). The caller applies its own staleness gate; the returned visibility lets it pause while
 * hidden. Listeners belong to the current component or effect scope (a Pinia store's included).
 */
export function useAppResume( onResume: () => void ): Readonly< Ref< DocumentVisibilityState > > {
    const visibility = useDocumentVisibility();

    watch( visibility, state => {
        if ( 'visible' === state ) {
            onResume();
        }
    } );
    useEventListener( 'online', onResume );

    return visibility;
}
